export enum ButtonCTAType {
  APP_EXCLUSIVE_CTA = 'APP_EXCLUSIVE_CTA',
  // @i18n-ignore
  B2B_SELF_SERVE = 'B2B_SELF_SERVE',
}

/**
 * Contentful flag class (add to a section's classNames or dynamic classes) marking that a
 * whole-image/container click should route through `navigateToB2BSelfServe` (D2C→B2B token
 * transfer) instead of a plain navigation. Lets a banner drop its visible CTA button and make
 * the entire image the B2B self-serve trigger, driven purely by Contentful.
 */
// eslint-disable-next-line i18next/no-literal-string -- Contentful CSS flag name
export const CONTAINER_CTA_B2B_SELF_SERVE_FLAG = 'cta-b2b-self-serve'
